import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { key: 1 }

import { computed } from 'vue';
import LinkButton from '@/shared/legacy/ui/button/link-button.vue';
import { appConfig } from '@/shared/legacy/lib/config/app-config';
import { useGlobal } from '@/shared/legacy/lib/use-global';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { $trlMessage } = useGlobal();
const userAgent = computed(() => appConfig.get('userAgent'));

return (_ctx: any,_cache: any) => {
  return (userAgent.value.plugin)
    ? (_openBlock(), _createElementBlock("ol", {
        key: 0,
        class: _normalizeClass(_ctx.$style.ol)
      }, [
        _createElementVNode("li", {
          class: _normalizeClass(_ctx.$style.li)
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.caption)
          }, _toDisplayString(_unref($trlMessage)('gs.magic-button.plugin.step.1')), 3),
          _createElementVNode("div", {
            class: _normalizeClass(_ctx.$style.description)
          }, [
            _createVNode(LinkButton, {
              class: _normalizeClass(_ctx.$style.link),
              to: userAgent.value.plugin,
              "data-qa": "install-magic-button",
              size: "l",
              color: "black",
              target: "_blank"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref($trlMessage)('magic-button.plugin.setup')), 1)
              ]),
              _: 1
            }, 8, ["class", "to"])
          ], 2)
        ], 2),
        (!userAgent.value.is_mobile)
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              class: _normalizeClass(_ctx.$style.li)
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.$style.caption)
              }, _toDisplayString(_unref($trlMessage)('gs.magic-button.plugin.step.2')), 3),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.$style.description)
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(_ctx.$style.group)
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.$style.key)
                  }, [
                    (userAgent.value.device === 'mac')
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(" alt ")
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode(" Alt ")
                        ], 64))
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.$style.keySign)
                  }, " + ", 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.$style.key)
                  }, " S ", 2)
                ], 2)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(_ctx.$style.info)
              }, _toDisplayString(_unref($trlMessage)('gs.magic-button.plugin.step.2.or')), 3)
            ], 2))
          : _createCommentVNode("", true)
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "unsupported", {}, () => [
          _createTextVNode(_toDisplayString(_unref($trlMessage)('gs.magic-button.plugin.not_supported')), 1)
        ])
      ]))
}
}

})